<template>  
    <div>  
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
		<div class="stepForm" v-if="success == '3'">
            <div class="mainTitle text-center mt-4 mb-3"> 
                <h3 class="mb-4">{{$t('verf_reqProcessing')}}</h3>
            </div> 
           
        </div>
        <div class="stepForm" v-if="success == true">
            <div class="mainTitle text-center mt-4 mb-3"> 
                <h3 class="mb-4">{{ $t('verf_reqVerify') }}</h3>
            </div> 
            <div class="CustomBlockWidth inMiddle-area whitebox p-4 middleBox">  
                <div class="congratulations">
                    <div class="logo_congrats">
                        <img src="../../../../static/fxView/images/check.svg" alt="Request Verify">
                    </div>
                    <div class="subtitle">
                        <h3>{{ $t('verf_dear') }} <span class="green">{{get_user.username}}</span></h3>
                        <p>{{ $t('bver_bonusVerMsz1') }}</p>
                    </div>
                    <div class="signupbtn full-width submitButton w-100 mt-4 text-center">
                        <router-link :to="{path:'/deposit-bonus',query:{tab: 'list'}}" class="prism_btn btn_sm">{{ $t('bver_backBonusList') }}</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="stepForm" v-if="success == false">
            <div class="mainTitle text-center mt-4 mb-3"> 
                <h3 class="mb-4">{{ $t('bver_reqFailed') }}</h3>
            </div> 
            <div class="CustomBlockWidth inMiddle-area whitebox p-4 middleBox">  
                <div class="congratulations">
                    <div class="logo_congrats">
                        <img src="../../../../static/fxView/images/cross.svg" alt="Request Failed">
                    </div>
                    <div class="subtitle">
                         <h3>{{ $t('verf_dear') }} <span class="green">{{get_user.username}}</span></h3>
                         <p>{{ $t(msg) }}</p>
                    </div>
                    <div class="signupbtn full-width submitButton w-100 mt-4 text-center">
                        <router-link :to="{path:'/deposit-bonus', query:{tab: 'list'}}" class="prism_btn btn_sm">{{ $t('bver_backBonusList') }}</router-link>
                    </div>
                </div>
            </div> 
        </div>
    </div> 
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'bonus',
        mixins: [fxViewMixins],
        data() {
            return {
                verify : '',
                success : '3',
                msg : '',
                pageLoader : false,
                response_msg : '',
                msg_type : '',
				type : ''
            }
        },
        created(){
            let query = Object.assign({}, this.$route.query);
            if(this.$route.query.verify){
                this.verify = query.verify
				this.type = query.type
				
				let input_json = {
                    'globalParams' : {
                        'verify' : this.verify.toString()
                    } ,'localParams' : {'parameter' : this , 'params' :'request-verify'}
                }
				
				if(this.type == 'REMOVE_BONUS'){
                    this._runRemoveBonus(input_json)
                }else{
                    this._runBonusCheckOtp(input_json)
                }
                
                delete query.verify;
				delete query.type;
                this.$router.replace({ query });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/bonus/bonus_verify.vue